import React from 'react';
import { useParams } from 'react-router-dom';
import { usePublicRestaurantAccess, isRestaurantActive } from '../lib/access-status';
import { PublicSuspendedScreen } from './PublicSuspendedScreen';
interface PublicRestaurantGateProps {
  /**
   * Slug explícito (modo subdominio). En modo marketplace se omite y se
   * toma de la ruta `/r/:slug/...`. Nunca hay slugs ni ids fijos: la
   * condición depende de lo que diga `access_status` para el restaurante
   * que el visitante está pidiendo.
   */
  slug?: string;
  children: React.ReactNode;
}

/** Carga neutra — sin menú, precios ni marca del restaurante. */
function CheckingScreen() {
  return <div className="min-h-screen bg-[#FBF7F2] flex items-center justify-center" data-id="element-2497" data-mp="eqqnl5pcrav4">
      <div className="w-8 h-8 border-4 border-[#8B5E3C] border-t-transparent rounded-full animate-spin" data-id="element-2498" data-mp="itwvsiw0zc48" />
    </div>;
}

/**
 * Control de acceso de la cara PÚBLICA de un restaurante.
 *
 * Misma fuente de verdad que el panel administrativo:
 * `restaurants.access_status`. Con `'active'` la página funciona igual que
 * siempre; con cualquier otro valor el árbol público de ESE restaurante no
 * se renderiza —ni menú, ni productos, ni precios, ni carrito, ni botón de
 * pedido, ni checkout— y en su lugar se muestra un aviso neutro.
 *
 * El marketplace global y los demás restaurantes no se ven afectados,
 * porque este control solo envuelve las rutas de un restaurante concreto.
 */
export function PublicRestaurantGate({
  slug,
  children
}: PublicRestaurantGateProps) {
  const params = useParams<{
    slug?: string;
  }>();
  const effectiveSlug = slug || params.slug;
  const {
    status,
    loading
  } = usePublicRestaurantAccess(effectiveSlug);

  // Sin slug no hay restaurante que verificar (rutas heredadas sin slug).
  // El bloqueo de pedidos en esos casos lo garantiza el servidor.
  if (!effectiveSlug) {
    return <>{children}</>;
  }

  // Nunca se renderiza el menú antes de conocer el estado.
  if (loading) {
    return <CheckingScreen data-id="element-2499" data-mp="2743l3xqos326" />;
  }
  if (!isRestaurantActive(status)) {
    return <PublicSuspendedScreen data-id="element-2500" data-mp="z2tlcprspqxj" />;
  }
  return <>{children}</>;
}